import {memo} from "react";

export const FormInputIcon = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 20.0001H11C10.4695 20.0001 9.96082 19.7894 9.58575 19.4142C9.21069 19.0392 8.99997 18.5304 8.99997 18M8.99997 18C8.99997 18.5304 8.78925 19.0392 8.41417 19.4142C8.03911 19.7894 7.5304 20.0001 6.99997 20.0001H5.99997M8.99997 18V6.00003M8.99997 6.00003C8.99997 5.4696 8.78925 4.96089 8.41417 4.58582C8.03911 4.21074 7.5304 4.00004 6.99997 4.00004H5.99997M8.99997 6.00003C8.99997 5.4696 9.21069 4.96089 9.58575 4.58582C9.96082 4.21074 10.4695 4.00004 11 4.00004H12M13 8.00003H19.9999C20.5303 8.00003 21.0391 8.21075 21.4141 8.58582C21.7893 8.9609 21.9999 9.46961 21.9999 10V14C21.9999 14.5305 21.7893 15.0392 21.4141 15.4143C21.0391 15.7893 20.5303 16.0001 19.9999 16.0001H13M4.99996 16.0001H3.99997C3.46953 16.0001 2.96083 15.7893 2.58576 15.4143C2.21068 15.0392 1.99996 14.5305 1.99996 14V10C1.99996 9.46961 2.21068 8.9609 2.58576 8.58582C2.96083 8.21075 3.46953 8.00003 3.99997 8.00003H4.99996"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

FormInputIcon.displayName = "FormInputIcon";
